/**
 * @flow
 */

import React, { useState, useCallback } from 'react';

import { Modal, Avatar } from '../../../../components';
import PersonalInformation from './PersonalInformation';
import SalonConnectionForm from '../form/SalonConnectionForm';
import Navigation from './Navigation';

import type { ModalDialog, Supplier } from '../../../../type';

type SupplierDetailsProps = {
    supplier: Supplier,
    onSupplierUpdate: Function,
} & ModalDialog;

function SupplierDetails({
    supplier,
    trigger,
    onClose,
    open,
    onSupplierUpdate,
}: SupplierDetailsProps) {
    const [selectedItem, setSelectedItem] = useState('personalInformation');

    const onItemClick = useCallback((e, { name }) => {
        setSelectedItem(name);
    }, []);

    return (
        <Modal onClose={onClose} open={open} trigger={trigger}>
            <Modal.Header>
                <Avatar
                    name={`${supplier.firstName} ${supplier.lastName}`}
                    size={48}
                    spaced="right"
                    round
                />
                {`${supplier.firstName} ${supplier.lastName}`}
                <Navigation selectedItem={selectedItem} onItemClick={onItemClick} />
            </Modal.Header>
            {selectedItem === 'personalInformation' ? (
                <PersonalInformation
                    onClose={onClose}
                    supplier={supplier}
                    open={open}
                    onSupplierUpdate={onSupplierUpdate}
                />
            ) : (
                <SalonConnectionForm onClose={onClose} supplier={supplier} />
            )}
        </Modal>
    );
}

export default SupplierDetails;
